import React, { useEffect, useState } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { Button, Form, Row, Col, Modal, Input, Select } from "antd";

import {
  validateColor,
  validatePrice,
  validateObservation,
} from "../validations";

import { checkValueFirebase,checkCategory,fetchData,collections } from "../../../../utils";

const { TextArea } = Input;
const { Option } = Select;

export const ModalNewProduct = ({
  isModalOpen,
  setIsModalOpen,
  dataSource,
  setDataSource,
}) => {
  const [form] = Form.useForm();

  const handleOk = (values) => {
    setIsModalOpen(false);
    const newData = {
      key: values.sku.toUpperCase(),
      category: values.category.toUpperCase(),
      brand: values.brand.toUpperCase(),
      size: values.size ? values.size.toUpperCase() : "NO APLICA",
      sku: values.sku.toUpperCase(),
      model: values.model.toUpperCase(),
      color: values.color.toUpperCase(),
      quantity: Number(values.quantity),
      total: Number(values.total),
      observation: values.observation ? values.observation.toUpperCase() : "SIN OBSERVACIONES"
    };
    setDataSource([...dataSource, newData]);
    form.resetFields();
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const querydb = getFirestore();

  const mapDocs = (res) => {
    return res.docs.map((ele) => ({ id: ele.id, ...ele.data() }));
  };
  
  const [sizes,setSizes] = useState();
  const [brands,setBrands] = useState();
  const [categories,setCategories] = useState();

  // download data for categories,brand and sizes
  useEffect(() => {
    getDocs(collection(querydb, "sizes")).then((res) => {
      setSizes(mapDocs(res));
    });
    fetchData(querydb,collections.brands,setBrands);
    fetchData(querydb,collections.categories,setCategories);
  }, [querydb]);

  // restrain the sizes in the form
  const handleSize = async (values) => {
    
    if(values.category){
      const categorySize = checkCategory(values.category);

      await checkValueFirebase(querydb,"sizes","type",categorySize,"data").then((res) => {
        setSizes(mapDocs(res));
      });
    }else{
      console.log("category undefined");
    }
  }

  return (
    <Modal
      title="Añadir Producto"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      okButtonProps={{
        style: {
          display: "none",
        },
      }}
      cancelButtonProps={{
        style: {
          display: "none",
        },
      }}>
      <Form 
      form={form} 
      name="control-hooks" 
      onFinish={handleOk}
      onValuesChange={handleSize}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="category"
              label="Categoría"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Select placeholder="Seleccione una opcion">
              {categories && categories.length ? 
                categories.map((category,i) => 
                <Option value={category.name} key={i}>{category.name}</Option>)
              :null}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="brand"
              label="Marca"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Select placeholder="Seleccione una opcion">
              {brands && brands.length ? 
                brands.filter(brand => brand.status !== false).map((brand,i) => 
                <Option value={brand.name} key={i}>{brand.name}</Option>) 
              : null}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="model"
              label="Modelo"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="sku"
              label="SKU"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          {form.getFieldValue('category') && categories.find(category => category.name === form.getFieldValue('category')).size !== "NO APLICA" ? 
          <Col span={12}>
            <Form.Item
              name="size"
              label="Talla"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Select placeholder="seleccione una opcion">
                {sizes && sizes?.map((size,i) => {
                  return <Option
                  key={i}
                  value={size.size}
                  name={size.size}
                  label={size.size}
                  >
                    {size.size}
                  </Option>
                })}
              </Select>
            </Form.Item>
          </Col> 
        : null}
          <Col span={12}>
            <Form.Item
              name="color"
              label="Color"
              rules={[
                {
                  required: true,
                },
                {
                  validator: validateColor,
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="quantity"
              label="Cantidad"
              rules={[
                {
                  required: true,
                  pattern: /^[0-9]+$/,
                  message: "Ingrese solo números enteros",
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="total"
              label="Precio Total"
              rules={[
                {
                  required: true,
                },
                {
                  validator: validatePrice,
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="observation"
          label="Observación"
          rules={[
            {
              required: false,
            },
            {
              validator: validateObservation,
            },
          ]}>
          <TextArea rows={4} />
        </Form.Item>
        <div className="footer-btn-modal">
         
          <div>
            <Button onClick={() => handleCancel()} size="large">
              Cancelar
            </Button>
          </div>
          <Form.Item className="button-right">
            <Button type="primary" htmlType="submit" size="large">
              Guardar
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};
